import React from "react";
import { Accordion } from "../../nq-component";
import Item from "./Item";

function Child({ menu, onClick, setActiveItem, activeItem }) {
  const { name, icon, label, route, id } = menu;
  let key = id || label || name.replaceAll(" ", "");
  return (
    <React.Fragment key={key}>
      <li className="nav-item">
        <Accordion
          eventKey={key}
          className="nav-link font-size-sm text-truncate p-2 mb-1"
        >
          <div className="d-inline">
            <i className={icon}></i>
            <span className="ms-3 text-wrap">{label || name}</span>
          </div>
          <div className="float-end ">
            <i className="bi bi-chevron-down ms-2"></i>
          </div>
        </Accordion>
      </li>
      <Accordion.Collapse eventKey={key}>
        <ul className="navbar-nav ms-4">
          {route.map((m, i) => (
            <Item
              key={i}
              menu={m}
              onClick={onClick}
              setActiveItem={setActiveItem}
              activeItem={activeItem}
            />
          ))}
        </ul>
      </Accordion.Collapse>
    </React.Fragment>
  );
}

export default Child;
